import React from 'react';
import {PlayersDashboard as BasePlayersDashboard} from 'desktop/sports/golf/players-dashboard/classic';

class PlayersDashboard extends BasePlayersDashboard {}

export {PlayersDashboard};
